import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'

export default function Terms() {
  return (
    <VStack space="md" className="p-6">
      <Text size="title-2" bold className="text-center">
        金数据使用条款
      </Text>
      <Text className="text-typography-500">【本次更新时间:2022年9月】</Text>
      <Text>西安数据如金信息科技有限公司（以下简称“数据如金科技”或“我们”）</Text>
      <Text>您:金数据®的注册用户(以下简称用户或“您”)</Text>
      <Text>
        金数据是数据如金科技旗下的基于表单的数据收集管理平台，致力于提供人人可用的在线表单工具。金数据的使用者包括为表单设计发布的表单创建者、表单发布者和表单填写者。
      </Text>

      <Text>
        您确认：在您开始“金数据”产品试用或购买前，您已充分阅读、理解并接受本协议的全部内容，一旦您选择“同意”并开始使用本服务或完成购买流程，即表示您同意遵循本协议之所有约定。不具备前述条件的，您应立即终止注册或停止使用本服务。
      </Text>
      <Text>
        数据如金科技有权根据法律法规、集团政策调整随时对本协议内容进行单方面变更，并以在jinshuju.net公告的方式予以公布，请您在公告处查看；若您在本协议内容公告变更后继续使用本服务，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务。您可以访问
        https://jinshuju.net/terms 来了解最新版本的服务条款。
      </Text>

      <Text size="title-3" bold className="mt-4">
        一、账户注册及条款
      </Text>
      <Text>
        1.
        您保证具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人；本协议内容不会被您所属国家或地区的法律禁止。
      </Text>
      <Text>2. 具体操作使用人应该是自然人。不允许采用注册机或者类似的自动化方式注册账户。</Text>
      <Text>3. 当您注册时应当提供您正式的全名、邮件地址以及其他必要的信息以完成注册。</Text>
      <Text>4. 您的登录信息只能用于一个人，不允许多人共享登录信息。</Text>
      <Text>
        5. 您应当保护好自己的用户名及密码信息不被泄露。我们无法也不会保护因为您泄露用户名或密码导致的数据风险。
      </Text>
      <Text>6. 对于免费账户，您不能选择阻止广告显示。付费用户将没有广告显示。</Text>
      <Text>7. 同一个用户只能拥有一个免费账户。</Text>
      <Text>
        8.
        您在创建或发布表单收集信息时，特别是在收集表单填写者的个人信息(包括但不限于姓名、出生日期、身份证件号码、住址、通信通讯联系方式、账号密码、住宿信息)时:
      </Text>
      <Text className="ml-4">
        • 需在表单首部或其他足以引起表单填写者注意的位置，明示收集、使用表单信息的目的、方式和范围。
      </Text>
      <Text className="ml-4">
        •
        您保证收集、使用表单信息已取得表单填写者主动明示的同意，并遵循法律法规及行业标准规定，采取合理有效的技术措施保存和处理表单信息。
      </Text>
      <Text className="ml-4">
        •
        除表单中所载已为个人信息主体所明示授权的范围外，您保证未经表单填写者明示同意，不对外披露、传输、出租、出售或交易填写人的个人信息数据，不超出表单填写允许的范围使用表单信息；并且不违法使用表单信息。
      </Text>

      <Text size="title-3" bold className="mt-4">
        二、计费与发票条款
      </Text>
      <Text>1. 收费标准以[数据如金科技产品网站所列的价格为准]。</Text>
      <Text>2. “金数据”提供免费套餐和付费套餐供您选择使用。</Text>
      <Text>3. 一旦选择付费套餐、按照“金数据”要求的流程完成付款，即享有付费套餐专享的功能。</Text>
      <Text>
        4.
        “金数据”付费套餐服务采用先付费，后使用的方式。您需要预存或者预先支付付费套餐费用。如果您没有在付费套餐有效期结束前预先支付下个有效期的费用，即视作您主动选择终止付费套餐服务。
      </Text>
      <Text>5. 预先支付的付费套餐费用无法申请退款。</Text>

      <Text size="title-3" bold className="mt-4">
        三、产品服务条款
      </Text>
      <Text>
        1.
        数据如金科技将遵循《中华人民共和国网络安全法》等法律规定和《金数据使用条款》提供金数据产品服务。数据如金科技根据前述规定，有权对用户在使用金数据产品过程中的违反法律或使用条款的行为作出处理。
      </Text>

      <Text size="title-3" bold className="mt-4">
        四、知识产权条款
      </Text>
      <Text>1. 您提交的各种内容版权归属于您。</Text>
      <Text>
        2.
        数据如金科技提供的服务及产品(包括但不限于观感、设计、图标、代码等)的版权、商标权、专利权及其他知识产权均归属于数据如金科技。除非获得数据如金科技明确书面允许，您不得复制、重用任何HTML/CSS,
        JavaScript或者任何视觉设计，也不得对数据如金科技产品进行反向工程、分解或进行编译或其他修改。
      </Text>

      <Text size="title-3" bold className="mt-4">
        五、责任免除与责任限制
      </Text>
      <Text>
        1.
        “金数据”是一款数据收集工具，对于用户所收集之数据及信息，金数据平台所提供的服务仅为自动化收集、存储数据、信息处理平台功能，数据如金科技及金数据平台除非因法律、政府及司法配合以及其他紧迫原因，并不会主动浏览、获取、使用、披露任何用户账户中收集的数据信息，用户需对其使用账户及功能的全部行为负责，因用户违法所造成数据如金科技的损失、赔偿或第三方权利主张，则用户将承担全部法律责任及赔偿，使得数据如金科技免于遭受相关责任及赔偿。
      </Text>

      <Text size="title-3" bold className="mt-4">
        六、服务取消与终止条款
      </Text>
      <Text>
        1.
        您的账户一旦被终止，“金数据”有权（但非义务）对这个账户的数据保留30天，此期间只有账户管理员能够登录系统，执行查询、数据备份相关操作，之后数据会被从服务器彻底删除，并且无法恢复。
      </Text>

      <Text size="title-3" bold className="mt-4">
        七、其他条款
      </Text>
      <Text>
        1.
        如果本协议的某一条款或某一条款的一部分无效或不可执行，不影响本协议其他条款的有效性，无效或不可执行的条款将被视作已从本协议中删除。
      </Text>
      <Text>
        2. 本协议受中华人民共和国法律管辖。
        在执行本协议过程中如发生纠纷，双方应及时协商解决。协商不成时，任何一方均应向西安市雁塔区人民法院提起诉讼。
      </Text>
      <Text>3. 本条款最新修订于2022年9月，最终解释权归数据如金科技所有。</Text>
      <Text>4. 若有任何疑问，请发信至support@jinshuju.net 联系地址:陕西省西安市高新区高新五路4号汇诚国际16楼</Text>

      <Text className="text-typography-500 mt-6">至此，您已经详细阅读并已理解本协议，并同意严格遵守各条款和条件。</Text>
    </VStack>
  )
}
